import React from 'react';

const OrderCompleteIcon = ({ width, height }: { width: number; height: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 64 64" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 5.33301C46.7276 5.33301 58.667 17.2724 58.667 32C58.667 46.7276 46.7276 58.667 32 58.667C17.2724 58.667 5.33301 46.7276 5.33301 32C5.33301 17.2724 17.2724 5.33301 32 5.33301ZM44.6152 23.8281C43.7821 22.995 42.4308 22.9951 41.5977 23.8281L27.5508 37.876L22.3926 32.7178C21.5595 31.8847 20.2091 31.8847 19.376 32.7178C18.5429 33.5509 18.5429 34.9013 19.376 35.7344L26.8438 43.2021C27.2343 43.5927 27.8673 43.5927 28.2578 43.2021L44.6152 26.8457C45.4483 26.0126 45.4483 24.6612 44.6152 23.8281Z"
        fill="#43A047"
      />
    </svg>
  );
};

export default OrderCompleteIcon;
